import React  from 'react';
import PropTypes from 'prop-types';
import {ChromePicker} from 'react-color';

import './colorPicker.css';
import Button, {BUTTON_TYPES, BUTTON_SIZES} from '../Button';
import Label from '../Label';

export default function ColorPicker(props) {
  const {color, onChange, onDone, onDelete, showDelete} = props;
  const [isInitial, toggleInitial] = React.useState(true);
  
  const handleOnChange = (color) => {
    toggleInitial(false);
    onChange(color);
  };

  return (
    <div className="color-picker-container">
      <Label> Select Color </Label><br />
      <ChromePicker
        color={color}
        onChange={handleOnChange}
      />
      <div className="color-picker-button-container">
        <Button
          label={isInitial ? 'Cancel' : 'Done'}
          type={BUTTON_TYPES.CTA}
          onClick={onDone}
          size={BUTTON_SIZES.SMALL}
        />
        {showDelete && <Button label="Delete" type={BUTTON_TYPES.DELETE} onClick={onDelete} size={BUTTON_SIZES.SMALL} />}
      </div>

    </div>

  );
}

ColorPicker.propTypes = {
  color: PropTypes.string,
  onChange: PropTypes.func,
  onDone: PropTypes.func
};

ColorPicker.defaultProps = {
  color: '#234556',
  onChange: () => {},
  onDone: () => {}
};
